module.exports = __webpack_public_path__ + "account/assets/yt.9511a710.svg";